import CatalogListPresenter from "../components/catalog-list/presenter/catalog-list.js";

const listElement = document.querySelector(`.catalog-js-list`);
const catalogListComponent = new CatalogListPresenter(listElement);
catalogListComponent.init();
